import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { cn } from '../utils/cn';
export const StatCard = React.forwardRef(function StatCard(
  { label, value, change, icon, className, ...props },
  ref,
) {
  const isPositive = change !== undefined && change >= 0;
  const isNegative = change !== undefined && change < 0;
  return (
    <div
      ref={ref}
      className={cn('rounded-lg border border-edge-strong bg-surface p-6', className)}
      {...props}
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-fg-tertiary">{label}</p>
          <p className="mt-1 text-2xl font-semibold text-fg">{value}</p>
        </div>
        {icon && <div className="ml-4 flex-shrink-0 text-fg-tertiary">{icon}</div>}
      </div>
      {change !== undefined && (
        <div className="mt-3 flex items-center gap-1">
          <span
            className={cn(
              'text-sm font-medium',
              isPositive && 'text-success-600',
              isNegative && 'text-danger-600',
            )}
          >
            {isPositive ? (
              <ChevronUp size={16} className="inline" aria-hidden="true" />
            ) : (
              <ChevronDown size={16} className="inline" aria-hidden="true" />
            )}
            {Math.abs(change).toFixed(1)}%
          </span>
        </div>
      )}
    </div>
  );
});
